<template>
  <b-container>
    <b-row class="text-center pt-4">
      <b-col>
        <b-alert show :variant="variant">
          <p>{{ message }}</p>
        </b-alert>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
props: ['message', "variant"],
data: () => ({}),
computed: {},
methods:{},
components: {}
}
</script>
